import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/phone-banking")({
	component: PhoneBankingLayout,
});

function PhoneBankingLayout() {
	return <Outlet />;
}
